import { Box, Button, Modal, SpaceBetween } from '@cloudscape-design/components';

/**
 * BusinessUnitMismatchModal Component
 *
 * Displays when a shared URL's business unit doesn't match the user's current BU
 * Prompts user to switch business units or cancel
 */
export interface BusinessUnitMismatchModalProps {
  'visible': boolean;
  'currentBusinessUnitName': string;
  'requiredBusinessUnitName': string;
  'onSwitchBusinessUnit': () => void;
  'onDismiss': () => void;
  'data-testid'?: string;
}

export function BusinessUnitMismatchModal({
  visible,
  currentBusinessUnitName,
  requiredBusinessUnitName,
  onSwitchBusinessUnit,
  onDismiss,
  'data-testid': dataTestId,
}: BusinessUnitMismatchModalProps) {
  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      header="Switch Business Unit"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button
              variant="link"
              onClick={onDismiss}
              data-testid={`${dataTestId}-cancel`}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={onSwitchBusinessUnit}
              data-testid={`${dataTestId}-switch`}
            >
              Go to Preferences
            </Button>
          </SpaceBetween>
        </Box>
      }
      data-testid={dataTestId}
    >
      <Box>
        This shared link requires <strong>{requiredBusinessUnitName}</strong> access.
        You're currently viewing <strong>{currentBusinessUnitName}</strong>. Switch your
        business unit in Profile Preferences.
      </Box>
    </Modal>
  );
}
